export const formatNumberOfSeasons = (numberOfSeasons: number) =>
  numberOfSeasons === 1 ? '1 Season' : `${String(numberOfSeasons)} Seasons`;
